// TODO move login and register functionality to separate components
import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService} from '../../services/local-storage.service';
import {UserService} from '../../services/user/user.service';
import {AuthService} from '../../services/auth.service';
import {LanguageService} from '../../services/language.service';
import {CountryISO, PhoneNumberFormat, SearchCountryField} from 'ngx-intl-tel-input-gg';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {User} from '../../classes/User';

@Component({
  selector: 'app-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public signUpForm: FormGroup;
  public isLoggedIn = false;
  public isLoginFailed = false;
  public isSignUpSuccess = false;
  public isSignUpFailed = false;
  public errorMessage = '';

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  public type = 'login';

  currentUser: User;

  redirectUri = `?redirect_uri=${environment.frontendUrl}/home/login`;

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private localStorageService: LocalStorageService,
              private userService: UserService,
              private authService: AuthService,
              public languageService: LanguageService) {
    if (this.localStorageService.getToken()) {
      this.isLoggedIn = true;
      this.currentUser = this.localStorageService.getUser();
      window.location.href = `${environment.frontendUrl}`;
    }
  }

  public ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      loginEmail: ['', Validators.required],
      loginPassword: ['', Validators.required],
      rememberMe: [false]
    });

    this.signUpForm = this.formBuilder.group({
      registerEmail: ['', Validators.required],
      phone: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      registerPassword: ['', Validators.required],
      passwordConfirm: ['', Validators.required],
      confirmed: [false, Validators.requiredTrue]
    });

    const token: string = this.activatedRoute.snapshot.queryParamMap.get('token');
    const error: string = this.activatedRoute.snapshot.queryParamMap.get('error');

    if (token) {
      this.localStorageService.saveToken(token);
      this.userService.getCurrentUser().subscribe({
        next: (user: User) => {
          this.login(user);
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.isLoginFailed = true;
        }
      });
    } else if (error) {
      this.errorMessage = error;
      this.isLoginFailed = true;
    }
  }

  public login(user: User): void {
    this.localStorageService.saveUser(user);
    this.isLoginFailed = false;
    this.isLoggedIn = true;
    this.currentUser = user;
    this.languageService.switchLanguageByEnum(user.language);
    window.location.href = `${environment.frontendUrl}`;
  }

  onSignUpSubmit(): void {
    this.authService.register(this.signUpForm, this.languageService.getEnumValueByCurrentLang()).subscribe({
      next: () => {
        this.isSignUpSuccess = true;
        this.isSignUpFailed = false;
        window.location.href = `${environment.frontendUrl}`;
      },
      error: (data) => {
        this.errorMessage = data.error.message;
        this.isSignUpFailed = true;
      },
    });
  }

  onLoginSubmit(): void {
    this.authService.login(this.loginForm).subscribe({
      next: (data) => {
        if (data.user.roles.length === 1 && data.user.roles.includes('ROLE_USER')) {
          this.errorMessage = 'Access denied';
          this.isLoginFailed = true;
          return;
        }
        this.localStorageService.saveToken(data.accessToken);
        this.login(data.user);
      },
      error: (data) => {
        this.errorMessage = (data.status === 401) ? 'Incorrect login or password' : data.error.message;
        this.isLoginFailed = true;
      },
    });
  }

  googleLogin(): void {
    window.location.href = `${environment.backendBaseUrl}/oauth2/authorization/google` + this.redirectUri;
  }

  facebookLogin(): void {
    window.location.href = `${environment.backendBaseUrl}/oauth2/authorization/facebook` + this.redirectUri;
  }
}
